export default 'skill-bites-landing-page'
